import {ProjectView_AccessControl} from "../../access/acl"
import ProjectView from "../../project-view"

export class ProjectView_Page_AccessControl extends ProjectView_AccessControl {

    constructor(projectView:ProjectView) {
        super(projectView)
    }

    get canDuplicate() {
        return false
    }

    get canResetToDefault() {
        return false
    }

    get canSaveAsTemplate() {
        return false
    }

    get canLoadTemplate() {
        return false
    }
}

